const LOGOS = [
  { id: 1, file: "logo_01_wordmark.png", title: "Option 1 — Wordmark + Tile (Active)", desc: "Currently in use across the site. Clean wordmark with a small monogram tile." },
  { id: 7, file: "logo_07_bracket_tile.png", title: "Option 7 — Code Bracket Tile (Backup)", desc: "Held as a backup. Sharp tile with '< >' brackets and a two-line wordmark — leans into the technology side." },
];

export default function BrandLogos() {
  return (
    <div className="ct-container py-20 md:py-28" data-testid="brand-logos-page">
      <header className="max-w-3xl">
        <span className="ct-eyebrow">Brand Studio</span>
        <h1 className="mt-4 font-display text-4xl font-bold leading-tight tracking-tight text-[#0F172A] sm:text-5xl">
          Logo concepts for
          <br />
          <span className="text-neutral-700">Contentium Tech.</span>
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-600">
          Option 1 is currently active across the site. Option 7 is held as a backup
          should we want to lean more into the technology side.
        </p>
      </header>

      <div className="mt-14 grid gap-8 md:grid-cols-2">
        {LOGOS.map((l) => (
          <article
            key={l.id}
            data-testid={`logo-card-${l.id}`}
            className="overflow-hidden rounded-3xl border border-slate-200 bg-white"
          >
            <div className="grid place-items-center bg-[#FAFAFA] p-8 md:p-12">
              <img
                src={`/logos/${l.file}`}
                alt={l.title}
                className="max-h-[320px] w-auto object-contain"
              />
            </div>
            <div className="border-t border-slate-200 p-6 md:p-7">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-700">
                {`0${l.id}`}
              </p>
              <h2 className="mt-2 font-display text-xl font-semibold text-[#0F172A]">
                {l.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{l.desc}</p>
              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href={`/logos/${l.file}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 rounded-full bg-[#0F172A] px-4 py-2 text-xs font-semibold text-white hover:bg-[#1e293b]"
                >
                  Open full size
                </a>
                <a
                  href={`/logos/${l.file}`}
                  download
                  className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-[#0F172A] hover:border-neutral-700 hover:text-neutral-700"
                >
                  Download PNG
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
